import React from 'react';

/** Pittogramma legacy (favicon /assets/images/logo.png). Non sostituire con SVG inventati. */
const LEGACY_MARK = '/assets/images/logo.png';

/**
 * Logo pubblico: pittogramma legacy + wordmark testuale.
 * Favicon e apple-touch restano sullo stesso asset in index.html.
 */
export default function VcLogo({ className = '', height = 40, withWordmark = true }) {
  const h = Number(height) || 40;
  const markH = Math.round(h * 0.95);
  const markW = Math.round(markH * (426 / 575));

  return (
    <span
      className={`vc-logo-mark ${className}`}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}
    >
      <img
        src={LEGACY_MARK}
        alt=""
        width={markW}
        height={markH}
        decoding="async"
        style={{
          height: markH,
          width: markW,
          objectFit: 'contain',
          display: 'block',
          flexShrink: 0,
        }}
      />
      {withWordmark && (
        <span
          className="vc-logo-wordmark"
          style={{
            fontWeight: 700,
            fontSize: Math.round(h * 0.42),
            color: 'currentColor',
            letterSpacing: '-0.02em',
            lineHeight: 1.1,
          }}
        >
          Virtual Clinic
        </span>
      )}
    </span>
  );
}
